var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar-top",on:{"click":function($event){_vm.$emit('click')}}},[(_vm.kind === 'unassigned')?_c('span',{staticClass:"avatar-core",style:({
    backgroundColor: '#f2f7ff',
    height: _vm.size + 'px',
    width: _vm.size + 'px',
  })},[_c('svg',{attrs:{"viewBox":"0 0 14 9","width":"14px"}},[_c('path',{attrs:{"fill-rule":"evenodd","stroke":"none","fill":"#bcd4ff","d":"M9,4 C10.11,4 11,3.1 11,2 C11,0.9 10.11,0 9,0 C7.9,0 7,0.9 7,2 C7,3.1 7.9,4 9,4 L9,4 Z M9,5.2 C7.33,5.2 4,6.03 4,7.7 L4,9 L14,9 L14,7.7 C14,6.03 10.67,5.2 9,5.2 L9,5.2 Z M5,3 L3,3 L3,1 L2,1 L2,3 L0,3 L0,4 L2,4 L2,6 L3,6 L3,4 L5,4 L5,3 L5,3 Z"}})])]):(_vm.kind === 'Team')?_c('span',{staticClass:"avatar-core",style:({
    backgroundColor: '#f2f7ff',
    color: 'rgba(0,0,0,.56)',
    height: _vm.size + 'px',
    width: _vm.size + 'px',
  })},[_c('i',{staticClass:"fas fa-users"})]):(_vm.obj && _vm.obj.avatarColor)?_c('span',{staticClass:"avatar-core",class:{selectedColor: _vm.selected},style:({
      backgroundColor: ("#" + (_vm.obj.avatarColor)),
      height: _vm.size + 'px',
      width: _vm.size + 'px',
      fontSize: _vm.size * 0.4375 + 'px'
    })},[_vm._v("\n    "+_vm._s(_vm.getInitials)+"\n  ")]):(_vm.obj && !_vm.obj.avatarColor)?_c('span',{staticClass:"avatar-core",class:{selectedColor: _vm.selected},style:({
      backgroundColor: '#f2f7ff',
      color: '#48f',
      height: _vm.size + 'px',
      width: _vm.size + 'px',
    })},[_c('i',{staticClass:"far fa-envelope-open"})]):(_vm.number)?_c('span',{staticClass:"avatar-core",class:{selectedColor: _vm.selected},style:({
    backgroundColor: '#f2f7ff',
    color: 'rgba(0,0,0,.56)',
    height: _vm.size + 'px',
    width: _vm.size + 'px',
    fontSize: _vm.size * 0.4375 + 'px'
  })},[_vm._v("\n    "+_vm._s(_vm.number)+"\n  ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }